<div class="p-2">
  <div class="flex flex-wrap justify-content-between align-items-center mb-2">
    <div class="font-semibold text-2xl mb-3" data-clarity-unmask="true">Grupy</div>
    <div class="flex gap-3">
      <p-button *ngIf="canManageGroups" label="Dodaj nową grupę" icon="pi pi-plus" (onClick)="addNewGroup()" data-clarity-unmask="true"></p-button>
    </div>
  </div>
  <div class="main-card p-3">
    <p-tabView [(activeIndex)]="activeIndex" styleClass="tabview-lg">
      <p-tabPanel header="Aktywne">
        <ng-container *ngIf="activeIndex === 0">
          <app-lecture-groups-list
            [archived]="false"
            [resetTable]="resetTable.asObservable()"
          ></app-lecture-groups-list>
        </ng-container>
      </p-tabPanel>
      <p-tabPanel header="Zarchiwizowane">
        <ng-container *ngIf="activeIndex === 1">
          <app-lecture-groups-list [archived]="true"></app-lecture-groups-list>
        </ng-container>
      </p-tabPanel>
    </p-tabView>
  </div>
</div>
